import { Search } from '@mui/icons-material';
import { Box, InputAdornment, Typography } from '@mui/material';
import { ITenantWithRoles } from 'types/queries';
import { SearchField, ListItem } from './index';
import { IRole } from 'views/backoffice/roles/types';
import { useTenantSelector } from 'contexts/TenantSelectorContext';

export const TenantSelector = () => {
    const { filteredTenants, selectedTenant, setSelectedTenant, searchText, setSearchText, setRoleSelectorMode, setSelectedRole } =
        useTenantSelector();

    return (
        <>
            <Box position="sticky" top={0} zIndex={1} sx={(theme) => ({ backgroundColor: theme.palette.background.paper, pb: '8px' })}>
                <Typography
                    variant="body1"
                    sx={(theme) => ({
                        color: theme.palette.primary.dark,
                        fontWeight: 700,
                        p: '8px'
                    })}
                >
                    Tenants
                </Typography>
                <SearchField
                    InputProps={{
                        disableUnderline: true,
                        sx: (theme) => ({
                            backgroundColor: theme.palette.primary[300],
                            borderRadius: '16px',
                            '& input': { padding: '8px 12px' }
                        }),
                        startAdornment: (
                            <InputAdornment position="start">
                                <Search htmlColor="#D9D9D9" />
                            </InputAdornment>
                        )
                    }}
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                    sx={{ px: '8px', mb: '16px', height: '20px' }}
                    InputLabelProps={{ sx: { paddingLeft: 2 } }}
                    placeholder="Find in list"
                    fullWidth
                    type="search"
                    variant="filled"
                />
            </Box>
            <Box
                sx={{
                    height: '100%',
                    overflowY: 'auto',
                    display: 'flex',
                    flexDirection: 'column'
                }}
            >
                {filteredTenants.map((filteredTenant) => (
                    <ListItem
                        key={filteredTenant.tenant.id}
                        item={filteredTenant}
                        selected={Number(selectedTenant?.tenant?.id) === Number(filteredTenant.tenant.id)}
                        onChange={(changedTenant) => {
                            setSelectedTenant(changedTenant as ITenantWithRoles | null);
                            if (changedTenant && 'roles' in changedTenant && changedTenant.roles.length === 1) {
                                setSelectedRole(changedTenant.roles[0] as Pick<IRole, 'name' | 'id'> | null);
                            } else {
                                setSelectedRole(null);
                            }
                        }}
                        setRoleSelectorMode={setRoleSelectorMode}
                        setSearchText={setSearchText}
                    />
                ))}
            </Box>
        </>
    );
};
